import { BrandLogo } from "../components/BrandLogo";
import { siteConfig } from "../config/site";

export function HomePage() {
  return (
    <section className="grid min-h-full place-items-center p-10">
      <div className="flex w-full max-w-xl flex-col items-center text-center">
        <BrandLogo className="home-logo w-[min(78vw,520px)] select-none text-zinc-100" />

        <p className="mt-8 font-mono text-[10px] tracking-[0.26em] text-zinc-600">
          {siteConfig.tagline.toUpperCase()}
        </p>

        <div className="mt-10 flex items-center gap-3 font-mono text-[8px] tracking-[0.2em] text-zinc-700">
          <span className="status-dot" aria-hidden="true" />
          SELECT A TAB
        </div>
      </div>
    </section>
  );
}
